import { createAction, props } from '@ngrx/store'
import { AuctionEntity, ContactOrganizerPayload } from './auction.models'
import { HttpErrorResponse } from '@angular/common/http'

// this action is being used inside the
// init guard and the not-found at the moment
export const getAuctionSuccess = createAction('[Auction/API] get auction Success', props<{ auction: AuctionEntity }>())

export const loadAuction = createAction('[Auction/API] Load Auction', props<{ urlName: string }>())

export const loadAuctionSuccess = createAction(
  '[Auction/API] Load Auction Success',
  props<{ auction: AuctionEntity }>(),
)

export const loadAuctionsFailure = createAction(
  '[Auction/API] Load Auctions Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const reloadAuction = createAction('[Auction/API] Reload Current Auction')

export const redirectHomePage = createAction('[Auction/Page] Redirect Home Page', (skip = false) => ({ skip }))

export const acceptCookieConsent = createAction('[Auction] Accept cookies')

export const openContactOrganizerDialog = createAction('[Item] Open Contact Organizer Dialog')

export const contactOrganizer = createAction('[Auction/API] Contact Organizer')

export const contactOrganizerSend = createAction(
  '[Auction/API] Contact Organizer Send',
  props<{ payload: ContactOrganizerPayload }>(),
)

export const contactOrganizerSendSuccess = createAction('[Auction/API] Contact Organizer Send Success')

export const contactOrganizerSendFailure = createAction(
  '[Auction/API] Contact Organizer Send Failure',
  props<{ error: string }>(),
)

export const destroyAuction = createAction('[Auction/API] Destroy Auction')

export const dismissTippingMessage = createAction('[Auction/API] Dismiss Tipping Message')

export const initSelectedPaymentMethod = createAction(
  '[Auction/Page] Init Selected Payment Method',
  props<{ paymentAmount?: number }>(),
)

export const setSelectedPaymentMethod = createAction(
  '[Auction/Page] Set Selected Payment Method',
  props<{ paymentMethodUuid: string }>(),
)

export const clearSelectedPaymentMethod = createAction('[Auction/Page] Clear Selected Payment Method')
